import React from 'react';
import SphereAvatar from '../../molecules/sphere-avatar/sphere-avatar';
import type { GlyphColor } from '../../../types/glyph';
import './SphereIdentityAtom.scss';

export interface SphereIdentityAtomProps {
  glyph?: string;
  glyphColor?: GlyphColor;
  sphereId?: string;
  sphereName?: string;
  imageId?: string;
  size?: 'xsmall' | 'small' | 'medium' | 'large';
  showInitials?: boolean;
  className?: string;
  isPrivate?: boolean;
}

const SphereIdentityAtom: React.FC<SphereIdentityAtomProps> = ({
  glyph,
  glyphColor,
  sphereId,
  sphereName,
  imageId,
  size = 'medium',
  showInitials,
  className = '',
  isPrivate = false,
}) => {
  return (
    <div className={`sphere-identity-atom ${className}`}>
      <SphereAvatar
        glyph={glyph}
        glyphColor={glyphColor}
        sphereId={sphereId}
        sphereName={sphereName}
        imageId={imageId}
        size={size}
        showInitials={showInitials}
        className="sphere-identity-avatar-icon"
      />
      {isPrivate && (
        <i className="pi pi-lock sphere-identity-lock-icon" style={{ marginRight: '6px', color: 'var(--primary-color, #3B82F6)', fontSize: '0.875rem' }} />
      )}
      <span className="sphere-identity-atom-name">
        {sphereName ?? '\u00A0'}
      </span>
    </div>
  );
};

export default SphereIdentityAtom;
